// extracted by mini-css-extract-plugin
module.exports = {"card":"cardpayment_card__qsg6_","total":"cardpayment_total__3TNiN","btn_pay":"cardpayment_btn_pay__2KHEc"};